export default __webpack_public_path__ + "images/0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf.png";